import { generateHblPage } from '@/router/routes/imports/schedule.routes';
import { onHandRouteOption } from '@/router/routes/exports/exports.routes';

const getLoadPlanChildRoutes = (routePrefix: string, placeholder: boolean) => [
  {
    path: 'mixed/load-plan/:loadPlanId',
    meta: {
      pageTitle: 'Load Plan',
      breadcrumb: {
        label: 'Load Plan',
        routeName: `${routePrefix}MixedInterfacilityLoadPlan`,
        ...(placeholder ? { exact: false } : {}),
      },
    },
    ...(placeholder
      ? {
          name: `${routePrefix}MixedInterfacilityLoadPlan`,
        }
      : {
          component: () => import('@/layouts/EmptyRouterView.vue'),
          children: [
            generateHblPage(`${routePrefix}MixedInterfacilityLoadPlanHBL`),
            onHandRouteOption(`${routePrefix}MixedInterfacilityLoadPlanOnHand`),
          ],
        }),
  },
  {
    path: 'import/load-plan/:loadPlanId',
    meta: {
      pageTitle: 'Load Plan',
      breadcrumb: {
        label: 'Load Plan',
        routeName: `${routePrefix}ImportInterfacilityLoadPlan`,
        ...(placeholder ? { exact: false } : {}),
      },
    },
    ...(placeholder
      ? {
          name: `${routePrefix}ImportInterfacilityLoadPlan`,
        }
      : {
          component: () => import('@/layouts/EmptyRouterView.vue'),
          children: [generateHblPage(`${routePrefix}ImportInterfacilityLoadPlanHBL`)],
        }),
  },
  {
    path: 'export/load-plan/:loadPlanId',
    meta: {
      pageTitle: 'Load Plan',
      breadcrumb: {
        label: 'Load Plan',
        routeName: `${routePrefix}ExportInterfacilityLoadPlan`,
        ...(placeholder ? { exact: false } : {}),
      },
    },
    ...(placeholder
      ? {
          name: `${routePrefix}ExportInterfacilityLoadPlan`,
        }
      : {
          component: () => import('@/layouts/EmptyRouterView.vue'),
          children: [onHandRouteOption(`${routePrefix}ExportInterfacilityLoadPlanOnHand`)],
        }),
  },
  {
    meta: {
      breadcrumb: {
        label: 'Inventory',
        routeName: `${routePrefix}InterfacilityInventoryDrawer`,
        ...(placeholder ? { exact: false } : {}),
      },
      pageTitle: 'Inventory',
    },
    ...(placeholder
      ? {
          name: `${routePrefix}InterfacilityInventoryDrawer`,
        }
      : {
          component: () => import('@/layouts/EmptyRouterView.vue'),
          children: [
            generateHblPage(`${routePrefix}InterfacilityInventoryDrawerHBL`),
            onHandRouteOption(`${routePrefix}InterfacilityInventoryDrawerOnHand`),
          ],
        }),
    path: 'inventory',
  },
  {
    meta: {
      breadcrumb: {
        label: 'Inventory Expanded',
        routeName: `${routePrefix}InterfacilityInventoryDrawerExpanded`,
        ...(placeholder ? { exact: false } : {}),
      },
      pageTitle: 'Inventory Expanded',
    },
    ...(placeholder
      ? {
          name: `${routePrefix}InterfacilityInventoryDrawerExpanded`,
        }
      : {
          component: () => import('@/layouts/EmptyRouterView.vue'),
          children: [
            generateHblPage(`${routePrefix}InterfacilityInventoryDrawerExpandedHBL`),
            onHandRouteOption(`${routePrefix}InterfacilityInventoryDrawerExpandedOnHand`),
          ],
        }),
    path: 'inventory/expanded',
  },
];

const getLoadGuideChildRoutes = (placeholder: boolean) => [
  {
    path: 'mixed/load-guide/:loadGuideId',
    meta: {
      pageTitle: 'Load Guide',
      breadcrumb: {
        label: 'Load Guide',
        routeName: `MixedInterfacilityLoadGuide`,
        ...(placeholder ? { exact: false } : {}),
      },
    },
    ...(placeholder
      ? {
          name: `MixedInterfacilityLoadGuide`,
        }
      : {
          component: () => import('@/layouts/EmptyRouterView.vue'),
          children: [
            generateHblPage(`MixedInterfacilityLoadGuideHBL`),
            onHandRouteOption(`MixedInterfacilityLoadGuideOnHand`),
          ],
        }),
  },
  {
    path: 'import/load-guide/:loadGuideId',
    meta: {
      pageTitle: 'Load Guide',
      breadcrumb: {
        label: 'Load Guide',
        routeName: `ImportInterfacilityLoadGuide`,
        ...(placeholder ? { exact: false } : {}),
      },
    },
    ...(placeholder
      ? {
          name: `ImportInterfacilityLoadGuide`,
        }
      : {
          component: () => import('@/layouts/EmptyRouterView.vue'),
          children: [generateHblPage(`ImportInterfacilityLoadGuideHBL`)],
        }),
  },
  {
    path: 'export/load-guide/:loadGuideId',
    meta: {
      pageTitle: 'Load Guide',
      breadcrumb: {
        label: 'Load Guide',
        routeName: `ExportInterfacilityLoadGuide`,
        ...(placeholder ? { exact: false } : {}),
      },
    },
    ...(placeholder
      ? {
          name: `ExportInterfacilityLoadGuide`,
        }
      : {
          component: () => import('@/layouts/EmptyRouterView.vue'),
          children: [onHandRouteOption(`ExportInterfacilityLoadGuideOnHand`)],
        }),
  },
];

export const loadsRoutes = [
  {
    path: 'load',
    redirect: { name: 'LoadPlans' },
    component: () => import('@/layouts/EmptyRouterView.vue'),
    children: [
      {
        path: 'plans',
        component: () => import('@/layouts/EmptyRouterView.vue'),
        children: [
          {
            name: 'InterfacilityLoadPlans',
            path: '',
            redirect: { name: 'LoadsTable' },
            component: () =>
              import('@/components/schedule/interfacility/dashboard/InterfacilityDashboard.vue'),
            children: [
              {
                name: 'LoadsCalendar',
                meta: {
                  pageTitle: 'Loads Calendar',
                  breadcrumb: {
                    exact: false,
                    label: 'Load Plans',
                    routeName: 'LoadsCalendar',
                  },
                },
                path: 'calendar',
                component: () =>
                  import(
                    '@/components/schedule/interfacility/dashboard/view/InterfacilityDashboardCalendar.vue'
                  ),
                children: [...getLoadPlanChildRoutes('Calendar', true)],
              },
              {
                name: 'LoadsTable',
                meta: {
                  pageTitle: 'Loads Table',
                  breadcrumb: {
                    exact: false,
                    label: 'Load Plans',
                    routeName: 'LoadsTable',
                  },
                },
                path: 'table',
                component: () =>
                  import(
                    '@/components/schedule/interfacility/dashboard/view/InterfacilityDashboardTable.vue'
                  ),
                children: [...getLoadPlanChildRoutes('Table', true)],
              },
            ],
          },
          {
            meta: {
              pageTitle: 'Loads',
              breadcrumb: {
                label: 'Load Plans',
                routeName: 'LoadsCalendar',
              },
            },
            path: 'calendar',
            component: () => import('@/layouts/breadcrumb/BreadcrumbLayout.vue'),
            children: [...getLoadPlanChildRoutes('Calendar', false)],
          },
          {
            meta: {
              pageTitle: 'Loads',
              breadcrumb: {
                label: 'Load Plans',
                routeName: 'LoadsTable',
              },
            },
            path: 'table',
            component: () => import('@/layouts/breadcrumb/BreadcrumbLayout.vue'),
            children: [...getLoadPlanChildRoutes('Table', false)],
          },
        ],
      },
      {
        path: 'guides',
        component: () => import('@/layouts/EmptyRouterView.vue'),
        children: [
          {
            name: 'InterfacilityLoadGuides',
            path: '',
            meta: {
              pageTitle: 'Load Guides',
            },
            component: () =>
              import(
                '@/components/schedule/interfacility/load-guide/InterfacilityLoadGuideTable.vue'
              ),
            children: [...getLoadGuideChildRoutes(true)],
          },
          {
            meta: {
              pageTitle: 'Load Guides',
              breadcrumb: {
                label: 'Load Guides',
                routeName: 'InterfacilityLoadGuides',
              },
            },
            path: '',
            component: () => import('@/layouts/breadcrumb/BreadcrumbLayout.vue'),
            children: [...getLoadGuideChildRoutes(false)],
          },
        ],
      },
    ],
  },
];
